import { Controller } from "@hotwired/stimulus"

// Shows the "Auf Anfrage" indicator next to the customer select when the selected
// customer is flagged on_request. The flag is embedded on each option as
// data-on-request, so toggling needs no extra request. Attached to the same
// <select> as the "select" (SlimSelect) controller, which dispatches a native
// change event on selection.
export default class extends Controller {
  connect() {
    this.toggle()
  }

  toggle() {
    const option = this.element.selectedOptions[0]
    const onRequest = Boolean(option) && option.dataset.onRequest === "true"
    const icons = document.getElementsByClassName("on_request_icon")
    if (icons.length === 0) return

    icons[0].classList.toggle("hidden", !onRequest)
  }
}
